import React, { memo } from "react";

const EmailIcon: React.FC = memo(() => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6 15.3337C1.16 15.3337 0.783333 15.177 0.47 14.8637C0.156667 14.5504 0 14.1737 0 13.7337V4.13369C0 3.69369 0.156667 3.31702 0.47 3.00369C0.783333 2.69036 1.16 2.53369 1.6 2.53369H14.4C14.84 2.53369 15.2167 2.69036 15.53 3.00369C15.8433 3.31702 16 3.69369 16 4.13369V13.7337C16 14.1737 15.8433 14.5504 15.53 14.8637C15.2167 15.177 14.84 15.3337 14.4 15.3337H1.6ZM8 9.59369C8.06667 9.59369 8.13667 9.58369 8.21 9.56369C8.28333 9.54369 8.35333 9.51369 8.42 9.47369L14.08 5.93369C14.1867 5.86702 14.2667 5.78369 14.32 5.68369C14.3733 5.58369 14.4 5.47369 14.4 5.35369C14.4 5.08702 14.2867 4.88702 14.06 4.75369C13.8333 4.62036 13.6 4.62702 13.36 4.77369L8 8.13369L2.64 4.77369C2.4 4.62702 2.16667 4.62369 1.94 4.76369C1.71333 4.90369 1.6 5.10036 1.6 5.35369C1.6 5.48702 1.62667 5.60369 1.68 5.70369C1.73333 5.80369 1.81333 5.88036 1.92 5.93369L7.58 9.47369C7.64667 9.51369 7.71667 9.54369 7.79 9.56369C7.86333 9.58369 7.93333 9.59369 8 9.59369Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { EmailIcon };
